import { useEffect } from 'react';

interface SEOHelmetProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl?: string;
  ogImage?: string;
  ogType?: string;
  schema?: Record<string, unknown>;
}

export default function SEOHelmet({
  title,
  description,
  keywords,
  canonicalUrl = 'https://doujincenter.github.io',
  ogImage = 'https://readdy.ai/api/search-image?query=Colorful%20anime%20style%20website%20banner%20for%20otaku%20resource%20platform%2C%20vibrant%20warm%20colors%2C%20manga%20and%20anime%20related%20illustrations%2C%20Japanese%20style%20decorative%20elements%2C%20clean%20and%20modern%20design&width=1200&height=630&seq=og-default&orientation=landscape',
  ogType = 'website',
  schema,
}: SEOHelmetProps) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('keywords', keywords);

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', canonicalUrl);
    } else {
      const link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      link.setAttribute('href', canonicalUrl);
      document.head.appendChild(link);
    }

    setMeta('og:title', title, true);
    setMeta('og:description', description, true);
    setMeta('og:type', ogType, true);
    setMeta('og:url', canonicalUrl, true);
    setMeta('og:image', ogImage, true);
    setMeta('og:site_name', '宅宅资源库', true);
    setMeta('og:locale', 'zh_CN', true);

    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', title);
    setMeta('twitter:description', description);
    setMeta('twitter:image', ogImage);

    return () => {
      document.title = '宅宅资源库 - 二次元资源聚合平台';
    };
  }, [title, description, keywords, canonicalUrl, ogImage, ogType]);

  useEffect(() => {
    if (!schema) return;
    const scriptId = 'seo-jsonld';
    let script = document.getElementById(scriptId);
    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.setAttribute('type', 'application/ld+json');
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(schema);
    return () => {
      const el = document.getElementById(scriptId);
      if (el) el.remove();
    };
  }, [schema]);

  return null;
}